export interface CancelCharge {
    adjdtl_id: number
    cshitm_id?: number
    stdrv_id?: number
    equrv_id?: number
    ccsht_id?: number
    ctm_id?: number
    cpuse_id?: number
    adjsht_id: number
    apiece: number
    item_number: number
    charge: number
    comment: string
    extra: string
    is_settled: boolean
    settled_date?: Date
    delete_flug: boolean
    cancel_reg_date: Date
    cancel_staff_name: string
    ctm_name1: string
    ctm_name2: string
    ctm_pronunciation1: string
    ctm_pronunciation2: string
    old_member_id?: string
    code?: string
    reserve_reg_date?: Date
    reg_staff_name?: string
    reserve_edit_date?: Date
    edit_staff_name?: string
}
export interface ObjectToCancelChargeProps {
    adjdtl_id: number | string
    cshitm_id?: number | string
    stdrv_id?: number | string
    equrv_id?: number | string
    ccsht_id?: number | string
    ctm_id?: number | string
    cpuse_id?: number | string
    adjsht_id: number | string
    apiece: number | string
    item_number: number | string
    charge: number | string
    comment: string
    extra: string
    is_settled: boolean | string
    settled_date?: string
    delete_flug: boolean | string
    cancel_reg_date: string
    cancel_staff_name: string
    ctm_name1: string
    ctm_name2: string
    ctm_pronunciation1: string
    ctm_pronunciation2: string
    old_member_id?: string
    code?: string
    reserve_reg_date?: string
    reg_staff_name?: string
    reserve_edit_date?: string
    edit_staff_name?: string
}
export const ObjectToCancelCharge = (obj: ObjectToCancelChargeProps): CancelCharge => {
    return {
        adjdtl_id: typeof obj.adjdtl_id === "string" ? parseInt(obj.adjdtl_id) : obj.adjdtl_id,
        cshitm_id: typeof obj.cshitm_id === "string" ? parseInt(obj.cshitm_id) : obj.cshitm_id,
        stdrv_id: typeof obj.stdrv_id === "string" ? parseInt(obj.stdrv_id) : obj.stdrv_id,
        equrv_id: typeof obj.equrv_id === "string" ? parseInt(obj.equrv_id) : obj.equrv_id,
        ccsht_id: typeof obj.ccsht_id === "string" ? parseInt(obj.ccsht_id) : obj.ccsht_id,
        ctm_id: typeof obj.ctm_id === "string" ? parseInt(obj.ctm_id) : obj.ctm_id,
        cpuse_id: typeof obj.cpuse_id === "string" ? parseInt(obj.cpuse_id) : obj.cpuse_id,
        adjsht_id: typeof obj.adjsht_id === "string" ? parseInt(obj.adjsht_id) : obj.adjsht_id,
        apiece: typeof obj.apiece === "string" ? parseInt(obj.apiece) : obj.apiece,
        item_number: typeof obj.item_number === "string" ? parseInt(obj.item_number) : obj.item_number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
        comment: obj.comment,
        extra: obj.extra,
        is_settled: typeof obj.is_settled === "string" ? obj.is_settled == "1" : obj.is_settled,
        settled_date: typeof obj.settled_date === "string" ? new Date(obj.settled_date) : obj.settled_date,
        delete_flug: typeof obj.delete_flug === "string" ? obj.delete_flug == "1" : obj.delete_flug,
        cancel_reg_date: typeof obj.cancel_reg_date === "string" ? new Date(obj.cancel_reg_date) : obj.cancel_reg_date,
        cancel_staff_name: obj.cancel_staff_name,
        ctm_name1: obj.ctm_name1,
        ctm_name2: obj.ctm_name2,
        ctm_pronunciation1: obj.ctm_pronunciation1,
        ctm_pronunciation2: obj.ctm_pronunciation2,
        old_member_id: obj.old_member_id,
        code: obj.code,
        reserve_reg_date: typeof obj.reserve_reg_date === "string" ? new Date(obj.reserve_reg_date) : obj.reserve_reg_date,
        reg_staff_name: obj.reg_staff_name,
        reserve_edit_date: typeof obj.reserve_edit_date === "string" ? new Date(obj.reserve_edit_date) : obj.reserve_edit_date,
        edit_staff_name: obj.edit_staff_name,
    }
}